import { JobCandidateAttachedAttribute } from 'packages/talent/entities/JobCandidateAttachedAttribute';
import { EntityBuilder } from '@decahedron/entity';
import { container } from 'tsyringe';
import VueI18n from 'vue-i18n';
export var AttributeLabelType;
(function (AttributeLabelType) {
    AttributeLabelType["IDEAL"] = "ideal";
    AttributeLabelType["OK"] = "ok";
    AttributeLabelType["FAIL"] = "fail";
    AttributeLabelType["DISQUALIFIED"] = "disqualified";
})(AttributeLabelType || (AttributeLabelType = {}));
var AttributeHelper = /** @class */ (function () {
    function AttributeHelper() {
        this.i18n = container.resolve(VueI18n);
        this.idealAttributeLabelData = {
            type: AttributeLabelType.IDEAL,
            label: this.i18n.t('common.ideal'),
            class: 'ideal-color text-white',
        };
        this.okAttributeLabelData = {
            type: AttributeLabelType.OK,
            label: this.i18n.t('common.ok'),
            class: 'jds-bg-green-200 jds-text-green-600',
        };
        this.failAttributeLabelData = {
            type: AttributeLabelType.FAIL,
            label: this.i18n.t('attributes.fail'),
            class: 'jds-bg-red-200 jds-text-red-600',
        };
        this.disqualifiedAttributeLabelData = {
            type: AttributeLabelType.DISQUALIFIED,
            label: this.i18n.t('attributes.disqualified_label'),
            class: 'bg-red-700 jds-text-white',
        };
    }
    AttributeHelper.prototype.getComparableAttributesInJob = function (category, job, candidateAttributes) {
        var _this = this;
        if (!job || !job.attributes) {
            return [];
        }
        var attributes = EntityBuilder.buildMany(JobCandidateAttachedAttribute, job.attributes);
        var jobAttributeIds = [];
        attributes.map(function (attribute) {
            var _a, _b;
            attribute.value = (_b = (_a = candidateAttributes.find(function (candidateAttribute) { return candidateAttribute.id === attribute.id; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null;
        });
        job.attributes.forEach(function (attribute) { return jobAttributeIds.push(attribute.id); });
        var sortMap = {
            DQ: 4,
            Ideal: 3,
            OK: 2,
            fail: 1,
            null: 0,
        };
        return attributes.filter(function (attribute) { return attribute.category === category && jobAttributeIds.includes(attribute.id); }).sort(function (sortable, sortable2) {
            // Sort attributes based on the label
            if (sortMap[_this.getComparableAttributeLabel(sortable).label] < sortMap[_this.getComparableAttributeLabel(sortable2).label]) {
                return 1;
            }
            if (sortMap[_this.getComparableAttributeLabel(sortable).label] > sortMap[_this.getComparableAttributeLabel(sortable2).label]) {
                return -1;
            }
            return 0;
        });
    };
    AttributeHelper.prototype.getComparableAttributesNotInJob = function (category, job, candidateAttributes) {
        if (!job) {
            return candidateAttributes.filter(function (attribute) { return attribute.category === category; });
        }
        var attributesInJob = this.getComparableAttributesInJob(category, job, candidateAttributes).map(function (attribute) { return attribute.id; });
        return candidateAttributes.filter(function (candidateAttribute) { return candidateAttribute.category === category && !attributesInJob.includes(candidateAttribute.id); });
    };
    AttributeHelper.prototype.getComparableAttributeLabel = function (attribute) {
        var _a, _b, _c;
        if (attribute.value === null) {
            return { type: null, label: null, class: '' };
        }
        if (attribute.type === 'scale') {
            var attachedOption = (_a = attribute.metadata) === null || _a === void 0 ? void 0 : _a.options.find(function (option) { return option.id === attribute.value; });
            var idealOption = (_b = attribute.metadata) === null || _b === void 0 ? void 0 : _b.options.find(function (option) { return option.id === attribute.idealValue; });
            var requiredOption = (_c = attribute.metadata) === null || _c === void 0 ? void 0 : _c.options.find(function (option) { return option.id === attribute.requiredValue; });
            if (attribute.disqualifyOnFailure && attachedOption.position > (requiredOption === null || requiredOption === void 0 ? void 0 : requiredOption.position)) {
                return this.disqualifiedAttributeLabelData;
            }
            if (attachedOption.position <= (idealOption === null || idealOption === void 0 ? void 0 : idealOption.position)) {
                return this.idealAttributeLabelData;
            }
            if (attachedOption.position <= (requiredOption === null || requiredOption === void 0 ? void 0 : requiredOption.position)) {
                return this.okAttributeLabelData;
            }
            return this.failAttributeLabelData;
        }
        if (attribute.type === 'bool') {
            if (attribute.disqualifyOnFailure && parseInt(attribute.value) !== parseInt(attribute.requiredValue)) {
                return this.disqualifiedAttributeLabelData;
            }
            if (parseInt(attribute.value) === parseInt(attribute.idealValue)) {
                return this.idealAttributeLabelData;
            }
            if (parseInt(attribute.value) === parseInt(attribute.requiredValue)) {
                return this.okAttributeLabelData;
            }
            return this.failAttributeLabelData;
        }
    };
    AttributeHelper.prototype.isRequirementMatched = function (attribute) {
        return this.getComparableAttributeLabel(attribute).type === AttributeLabelType.IDEAL || this.getComparableAttributeLabel(attribute).type === AttributeLabelType.OK;
    };
    AttributeHelper.prototype.getReadableAttributeValue = function (attribute, attributeValue) {
        var _a, _b;
        if (attributeValue === null) {
            return '';
        }
        if (attribute.type === 'bool') {
            // @TODO: Figure out why some values are parsed as string from entity
            if (parseInt(attributeValue) === 1) {
                return this.i18n.t('common.yes');
            }
            if (parseInt(attributeValue) === 0) {
                return this.i18n.t('common.no');
            }
        }
        return ((_b = (_a = attribute.metadata) === null || _a === void 0 ? void 0 : _a.options.find(function (option) { return option.id === attributeValue; })) === null || _b === void 0 ? void 0 : _b.label) || '';
    };
    return AttributeHelper;
}());
export { AttributeHelper };
